import React from 'react'
import DropZone from '../../components/Dropzone'
import { format } from 'date-fns'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import Box from '@mui/material/Box'
import Paper from "@mui/material/Paper"
import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import TextField from "@mui/material/TextField"
import Checkbox from "@mui/material/Checkbox"
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Switch  from '@mui/material/Switch'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import CircularProgress from "@mui/material/CircularProgress"
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import config from '../../config.json'
import {Context as AppContext} from '../../contexts/App'
import { Context as NotificationsContext } from '../../contexts/Notifications'
import { Context as SalesChannelContext } from '../../contexts/SalesChannels'
import VendorPicker  from '../../components/vendorPicker'
import GroupedSales from './GroupedSales'

const failedDownloadSnack = "Liquidations-failedDownloadSnack"

const Liquidations = () => {
	const { vendor } = React.useContext(AppContext)
	const [prefix, setPrefix] = React.useState(null)
	const [folio, setFolio] = React.useState(null)
	const [disabled, setDisabled] = React.useState(false)
	const [memory, setMemory] = React.useState(false)
	const [date, setDate] = React.useState(null)
	const [difWc, setDifWC] = React.useState(false)
	const [wdate, setWDate] = React.useState(null)
	const [includeExtras, setIncludeExtras] = React.useState(null)
	const [filesAmazon, setAmazonFiles] = React.useState([])
	const [filesMercado, setMercadoFiles] = React.useState([])
	const [clear, setClear] = React.useState(false)
	  
	  
	const onChangeMemory = (e)=>{
		const c = !memory
		setMemory(c);
	}
	const onChangeWH = (e)=>{
		const c = !difWc
		if(difWc)
			setWDate(null)
		setDifWC(c);
	}

	const onChangeIncludeExtras = (e)=>{
		const c = !includeExtras
		setIncludeExtras(c)
	}

	React.useEffect(() => {
		setClear(true)
	}, [vendor])

	React.useEffect(() => {
		clear && setClear(false)
	}, [clear])

	const { liquidations } = React.useContext(SalesChannelContext).events
	const {createSnack, openSnack, deleteSnack} = React.useContext(NotificationsContext)

	React.useEffect(() => {
		createSnack(failedDownloadSnack, {message: "Falló la generación de liquidaciones"})
		return () => deleteSnack(failedDownloadSnack)
	}, [])

	const onError = () => {
		setDisabled(false)
		openSnack(failedDownloadSnack)
	}
	
	const downloadFile = (download) => {
		console.log("downloading file: ", config.api_url+download)
		window.open(config.api_url+download, "_blank")
		setDisabled(false)
		setClear(true)
	}

	const submitFile = e => {
		e.stopPropagation()
		setDisabled( true)
		const data = new FormData()
		data.append("payments", vendor === 'amazon'?filesAmazon[0]:filesMercado[0] )
		data.append("prefix", prefix)
		data.append("folio", folio)
		data.append("memory", memory)
		data.append("vendor", vendor)
		data.append("date", date)
		data.append("wdate", wdate)
		data.append("includeExtras", includeExtras)
		liquidations(data, downloadFile, onError)
	}

	const flag = filesAmazon.length > 0 || filesMercado.length > 0
	
	return (
		<div style={{
			display: 'flex',
			justifyContent: "center",
			margin: 'auto',
			width: 400,
			flexWrap: 'wrap',
		}}>
			<div style={{ width: '100%', float: 'left' }}>
				<h3>Subir reporte de pagos</h3> <br />
			</div>


			<Paper sx={{ cursor: flag?'auto':'pointer', position: 'relative', minWidth:"200px", minHeight: '200px', display: "flex", justifyContent: "space-around", alignItems: "center", flexDirection: "column",padding: "15px"}}>
				<VendorPicker/>
				<Box>
					<FormControl sx={{ m: 1, width: '25ch' }}>
						<DatePicker
							views={['year', 'month']}
							label="Fecha"
							name="date"
							onChange={(m) => console.log({m}, format(m, 'yyyy-MM')) || setDate(format(m, 'yyyy-MM'))}
							value={date?date+"-1":date}
							inputFormat="yyyy-MM"
							defaultValue={null}
							renderInput={(params) => <TextField {...params} inputProps={{...(params.inputProps || {}), readOnly: true}} />}
							
						/>
						<FormControl>
							<FormControlLabel control={
								<Switch
									onChange={onChangeIncludeExtras}
									name="includeExtras"
									checked={includeExtras}
								/>
							} label="Incluir costos de publicidad" />
						</FormControl>
						{includeExtras && 
							<React.Fragment>
								<FormControl>
									<FormControlLabel control={
									<Checkbox
										onClick={onChangeWH}
										name="difWc"
										checked={difWc}
									/>
								} label="Utilizar diferente fecha para almacenamientos" />
								</FormControl>
								{difWc && 
									<DatePicker
										views={['year', 'month']}
										label="Fecha Almacenamientos"
										name="date"
										onChange={(m) => console.log({m}, format(m, 'yyyy-MM')) || setWDate(format(m, 'yyyy-MM'))}
										value={wdate?wdate+"-1":wdate}
										inputFormat="yyyy-MM"
										defaultValue={null}
										renderInput={(params) => <TextField {...params} inputProps={{...(params.inputProps || {}), readOnly: true}} />}
										
									/>
								}
								<FormControl>
									<FormControlLabel control={
									<Checkbox
										onClick={onChangeMemory}
										name="memory"
									/>
								} label="Guardar eventos de venta" />
								</FormControl>
							</React.Fragment>
						}
						</FormControl>
						
				</Box>

			  <Box sx={{display:vendor === 'amazon'?'block':'none'}}>
			  	<DropZone accept=".csv" setFiles={setAmazonFiles} waitTitle="Reporte de Pagos"/>
			  </Box>
			  
			  
			  <Box sx={{display:vendor === 'mercado'?'block':'none'}}>
			  	<DropZone accept=".xlsx" setFiles={setMercadoFiles} waitTitle="Reporte de Ventas"/>
			  </Box>


				{flag &&
					<Box sx={{display:'flex', justifyContent:'flex-start', alignItems:'center', flexDirection:'row', flexWrap:'wrap'}}>
						<FormControl onClick={e => e.stopPropagation()} sx={{ m: 1, width: '10ch' }}>
							<TextField variant="outlined" 
								label="Prefijo" 
								name="prefix"
								value={prefix}
								onChange={e => setPrefix(e.target.value)}
							/>
						</FormControl>
						<FormControl onClick={e => e.stopPropagation()} sx={{ m: 1, width: '25ch' }}>
							<TextField variant="outlined" 
								label="Folio" 
								name="folio"
								value={folio}
								onChange={e => !isNaN(Number(e.target.value)) && setFolio(Number(e.target.value))}
							/>
						</FormControl>
					</Box>
				}
				<Button disabled={!flag || !folio || !prefix || !date || disabled} onClick={submitFile} variant="contained" color="primary">
					{disabled?<CircularProgress size={27}/>:'Generar liquidaciones'}
				</Button>
			</Paper>

			<Paper sx={{ marginTop: '30px', marginBottom: '60px'}}>
				<Accordion>
					<AccordionSummary expandIcon={<ExpandMoreIcon />}>
						<Typography>Ventas agrupadas</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<GroupedSales/>
					</AccordionDetails>
				</Accordion>
			</Paper>
			
		</div>
	)
}

export default Liquidations
